<template>
  <el-card class="card-main">
    <el-form ref="searchInfo" :model="searchForm" class="global-form" :inline="true">
      <el-form-item>
        <el-select v-model="searchForm.projectId" placeholder="请选择所属项目" filterable clearable>
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table class="global-table" stripe :data="tableData" v-loading="loading">
      <el-table-column prop="projectName" label="项目名称"></el-table-column>
      <el-table-column prop="total" label="设备总数"></el-table-column>
      <el-table-column prop="onlineNum" label="在线设备数"></el-table-column>
      <el-table-column prop="offlineNum" label="离线设备数"></el-table-column>
      <el-table-column label="操作" width="240px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="$router.push(`/deviceMap?projectId=${row.projectId}&deviceType=${deviceType}`)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination :total="total" :current-page.sync="page" :page-size.sync="size" @current-change="getList"
      @size-change="getList"></GlobalPagination>
  </el-card>
</template>

<script>
import { deviceTypeList } from '@/views/device/mapIcon'
export default {
  name: 'ProjectDeviceList',
  data() {
    return {
      searchForm: {
        projectId: ''
      },
      loading: false,
      tableData: [],
      total: 0,
      page: 1,
      size: 10
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    },
    deviceType() {
      return this.$route.query.deviceType
    }
  },
  watch: {
    deviceType() {
      this.getList()
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 搜索
    onSearch() {
      this.page = 1
      this.getList()
    },
    // 获取列表数据
    getList() {
      this.loading = true
      this.$axios.get(this.$apis.device.selectDeviceGroupProjectPage,
        {
          deviceProduct: deviceTypeList.get(this.deviceType),
          ...this.searchForm,
          page: this.page,
          size: this.size
        }).then(res => {
          this.total = res.total
          this.tableData = res.list
        }).finally(() => {
          this.loading = false
        })
    }
  }

}
</script>

<style scoped lang="scss">
.marLeft {
  margin-left: 0px;
}

.iconfont {
  font-size: 12px;
  margin-right: 8px;
}
</style>
